import { useState } from "react";

import TableFirmSettings from "../common/table-firm-settings";
import api from "../../../api/api";
import HintModal from "../common/hint-modal";

import useGetCards, {
  useChangeCardStatus,
  useDeleteCard,
  useGetAddCardsDetails,
} from "./hooks/useGetCardsTabAPI";
import StatusToggle from "./StatusToggle";
import AddEditCardModal from "./modals/add-edit-card";
import ImagePreviewModal from "./modals/image-preview-modal";

const CardsTab = () => {
  // const heading = "FIRM SETTINGS TITLE WITH CENTERED TEXT";
  const points = [
    "Firm settings panel instruction point one",
    "Firm settings panel instruction point two",
    "Firm settings panel instruction point three",
  ];

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [data, setData] = useState(null);
  const [editId, setEditId] = useState(null);
  const [previewImage, setPreviewImage] = useState({
    show: false,
    url: "",
    alt: "",
  });
  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  const handleImageClick = (imageUrl, imageAlt) => {
    setPreviewImage({
      show: true,
      url: imageUrl,
      alt: imageAlt,
    });
  };

  const handleClosePreview = () => {
    setPreviewImage({
      show: false,
      url: "",
      alt: "",
    });
  };

  const { data: cardsData, refetch: fetchCardsDetails } = useGetCards();
  const { changeStatus } = useChangeCardStatus();
  const { deleteCard } = useDeleteCard();
  const { data: modaldata } = useGetAddCardsDetails();
  const handleStatusToggle = async (id, newStatus) => {
    try {
      await changeStatus({
        card_id: id,
        is_active: newStatus,
      });
      await fetchCardsDetails();
    } catch (error) {
      console.error(error);
    }
  };

  const handleShowEditModal = async (cardId) => {
    try {
      const response = await api.get("/api/firmsetting-page/edit-card/", {
        params: { id: cardId },
      });
      setData(response.data);
      setEditId(cardId);
      setShowEditModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="tab-pane fade firm-settings-user-perms-fs active show">
      <div className="d-flex m-b-5">
        <h2 className="fw-bold w-100">Cards Settings</h2>
        <div className="d-flex justify-content-end">
          <button
            onClick={() => setShowAddModal(true)}
            style={{
              whiteSpace: "nowrap",
            }}
            className="btn btn-primary d-flex align-items-center height-25 me-3"
          >
            Create Card
          </button>
          <div
            onClick={() => {
              handleHintToggle();
            }}
          >
            <i className="ic ic-19 ic-help-2 cursor-pointer" />
          </div>
        </div>
      </div>

      <TableFirmSettings>
        <thead>
          <tr id="tb-header">
            <th className="text-center">Card Name</th>
            <th className="text-center">Message</th>
            <th className="text-center">HandWriting</th>
            <th className="text-center">Template</th>
            <th className="td-autosize text-center">Status</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {cardsData?.map((item) => (
            <tr style={{ height: "35px" }} key={item.id}>
              <td className="color-grey td-autosize">{item.name}</td>
              <td className="td-autosize">{item.message}</td>
              <td className="td-autosize">
                <img
                  className="thumbnail"
                  alt={`Handwritiing-image-${item.id}`}
                  src={item.handwriting_image_src}
                  onClick={() =>
                    handleImageClick(item.handwriting_image_src, `Handwriting-image-${item.id}`)
                  }
                />
              </td>
              <td className="td-autosize">
                <img
                  className="thumbnail"
                  alt={`template-image-${item.id}`}
                  src={item.template_image_src}
                  onClick={() =>
                    handleImageClick(item.template_image_src, `Handwriting-image-${item.id}`)
                  }
                />
              </td>
              <td className="td-autosize" style={{ width: "auto" }}>
                <StatusToggle
                  initialActive={item.is_active}
                  onToggle={(newStatus) => handleStatusToggle(item.id, newStatus)}
                />
              </td>
              <td className="td-autosize">
                <div className="d-flex">
                  <button
                    onClick={() => handleShowEditModal(item.id)}
                    className="btn btn-primary m-r-5 d-flex align-items-center height-25"
                  >
                    Edit
                  </button>
                  <button
                    onClick={async () => {
                      try {
                        await deleteCard(item.id);
                        await fetchCardsDetails();
                      } catch (error) {
                        console.error(error);
                      }
                    }}
                    className="btn btn-danger d-flex align-items-center height-25"
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </TableFirmSettings>

      {showAddModal && (
        <AddEditCardModal
          showModal={showAddModal}
          handleClose={() => setShowAddModal(false)}
          data={modaldata}
          refetch={fetchCardsDetails}
        />
      )}
      {showEditModal && (
        <AddEditCardModal
          showModal={showEditModal}
          handleClose={() => setShowEditModal(false)}
          data={modaldata}
          refetch={fetchCardsDetails}
          filledData={data}
          isEdit={true}
          editId={editId}
        />
      )}

      {previewImage?.show && (
        <ImagePreviewModal
          show={previewImage.show}
          handleClose={handleClosePreview}
          imageUrl={previewImage.url}
          imageAlt={previewImage.alt}
        />
      )}
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </div>
  );
};

export default CardsTab;
